module.exports = __webpack_public_path__ + "static/media/moduleSet_i2o3.7ea24c8a.jpg";